import { ClubLocalModule } from '@modules/application/application';

export const MemberStateLocalModule: ClubLocalModule = {
    code: '29a1f4b6af367947611bf6e683b4406a',
    icon: 'user',
    localEnabled: true,
    name: 'Estado de Socio / Pagos',
    url: 'state',
    includeInNavigation: true,
};
